import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import NotificationForm from '@/components/Notification/NotificationForm.vue';
import useAppMixin from '@/mixins/appMixin';
import { useNotificationStore } from '@/store/notification';
import Notification from '@/types/interfaces/Notification';
import { DEFAULT_PAGINATION_PAGE, DEVICE_PLATFORMS, PAGINATION_TABLES_NAMES, PROVIDE_KEYS } from '@/utils/constants';
import { escapeString } from '@/utils/functions';
import { inject, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleNotification',
  setup(__props) {

const { setPageTitle } = useAppMixin();
const { handleUpdatePage } = useTablePaginationMixin();

const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);

const route = useRoute();
const router = useRouter();
const notificationStore = useNotificationStore();
const inProcess = ref(false);
const notificationId = route.params.id;
const modeEdit = notificationId != undefined;
const existedNotification = ref({});
const showForm = ref(false);

const loadNotification = async () => {
  await notificationStore.fetchNotification(Number(notificationId)).then((serverNotification: Notification) => {
    showForm.value = true;
    existedNotification.value = serverNotification;
  });
};

if (modeEdit) {
  setPageTitle('PageTitle.Notifications.Edit');
  loadNotification();
} else {
  setPageTitle('PageTitle.Notifications.Create');
  showForm.value = true;
}

function onSubmitNotificationForm(data: { formData: any; send: boolean }) {
  inProcess.value = true;
  
  if (modeEdit) {
    const existedNotificationLocal = existedNotification.value as Notification;

    const updNotification: Notification = {
      id: existedNotificationLocal.id,
      media: data.formData.mediaFiles ?? []
    };
    if (existedNotificationLocal.title != data.formData.title) {
      updNotification.title = data.formData.title;
    }
    if (existedNotificationLocal.content != data.formData.notification) {
      updNotification.content = escapeString(JSON.stringify(data.formData.notification));
    }
    if (existedNotificationLocal.platform != data.formData.platform) {
      updNotification.platform = data.formData.platform == DEVICE_PLATFORMS.All ? null : data.formData.platform;
    }
    if (existedNotificationLocal.withPush != data.formData.withPush) {
      updNotification.withPush = data.formData.withPush;
    }
    if (existedNotificationLocal.versions != data.formData.versions) {
      updNotification.versions = data.formData.versions.length > 0 ? data.formData.versions.split(',') : null;
    }
    if (existedNotificationLocal.minVersion != data.formData.minVersion) {
      updNotification.minVersion = data.formData.minVersion.length > 0 ? data.formData.minVersion : null;
    }
    if (existedNotificationLocal.maxVersion != data.formData.maxVersion) {
      updNotification.maxVersion = data.formData.maxVersion.length > 0 ? data.formData.maxVersion : null;
    }
    const formDataMetadata = JSON.stringify(data.formData.metadata);
    if (existedNotificationLocal.metadata != formDataMetadata) {
      updNotification.metadata = formDataMetadata;
    }

    notificationStore
      .updateNotification(updNotification)
      .then((updatedNotification: Notification) => {
        if (data.send) {
          sendNotification(updatedNotification.id!);
        } else {
          router.back();
          showSnackbar('ResponseMessage.Notification.Update.Success');
        }
      })
      .catch(() => {
        showSnackbar('ResponseMessage.Notification.Update.Error');
      })
      .finally(() => (inProcess.value = false));
  } else {
    let meta = { isLocalized: true, ...data.formData.metadata };
    let content = data.formData.notification;
    for (let key in content) {
      if (content[key].length == 0) {
        delete content[key];
      }
    }

    const newNotification: Notification = {
      title: data.formData.title,
      content: escapeString(JSON.stringify(content)),
      metadata: JSON.stringify(meta),
      withPush: data.formData.withPush,
      media: data.formData.mediaFiles ?? []
    };

    if (data.formData.platform != DEVICE_PLATFORMS.All) {
      newNotification.platform = data.formData.platform;
    }
    if (data.formData.versions.length > 0) {
      newNotification.versions = data.formData.versions.split(',');
    }
    if (data.formData.minVersion.length > 0) {
      newNotification.minVersion = data.formData.minVersion;
    }
    if (data.formData.maxVersion.length > 0) {
      newNotification.maxVersion = data.formData.maxVersion;
    }
    
    notificationStore
      .createNotification(newNotification)
      .then((createdNotification: Notification) => {
        if (data.send) {
          sendNotification(createdNotification.id!);
        } else {
          handleUpdatePage(PAGINATION_TABLES_NAMES.CLIENTS, DEFAULT_PAGINATION_PAGE);
          router.back();
          showSnackbar('ResponseMessage.Notification.Create.Success');
        }
      })
      .catch(() => {
        showSnackbar('ResponseMessage.Notification.Create.Error');
      })
      .finally(() => (inProcess.value = false));
  }
}

function sendNotification(notificationId: number) {
  notificationStore
    .sendNotification(notificationId)
    .then(
      () => {
        handleUpdatePage(PAGINATION_TABLES_NAMES.NOTIFICATONS, DEFAULT_PAGINATION_PAGE);
        router.back();
        showSnackbar('ResponseMessage.Notification.Send.Success');
      },
      () => {
        showSnackbar('ResponseMessage.Notification.Send.Error');
      }
    )
    .catch(() => {
      showSnackbar('ResponseMessage.Notification.Send.Error');
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      (showForm.value)
        ? (_openBlock(), _createBlock(NotificationForm, {
            key: 0,
            inProcess: inProcess.value,
            formData: existedNotification.value,
            edit: modeEdit,
            onSubmitForm: onSubmitNotificationForm
          }, null, 8, ["inProcess", "formData"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})